{
	"no-face-detected": "No face detected",
	"try-a-different-image": "Try with a different image"
}
